import { transitionEnd } from '../../02-tools'

let triggered = false
let readMoreInstances = {}

export function ReadMore() {
    if (triggered) {
        return
    }

    triggered = true

    document.addEventListener('click', (evt) => {
        if (
            evt.target.classList.contains('u-read-more') ||
            evt.target.classList.contains('js-readmore')
        ) {
            toggleReadMore(evt)

            const parent = evt.target.closest('.js-read-more-container')

            if (parent) {
                parent.remove()
            }
        }
    })
}

function toggleReadMore(evt) {
    let button = evt.target
    let controlId = button.getAttribute('aria-controls')

    if (!readMoreInstances[controlId]) {
        let container = document.querySelector('#' + controlId)

        if (!container) {
            return
        }

        readMoreInstances[controlId] = {
            button,
            container,
            animationFrame: null,
            isOpen: button.getAttribute('aria-expanded') === 'true'
        }

        transitionEnd(container).subscribe((evt) => transitionEndTasks(evt, controlId))
    }

    if (readMoreInstances[controlId].isOpen) {
        close(controlId)
    } else {
        open(controlId)
    }
}

function transitionEndTasks(evt, controlId) {
    const { container, button, isOpen } = readMoreInstances[controlId]

    if (evt.target !== container) {
        return
    }

    if (isOpen) {
        container.style.height = 'auto'
    } else {
        container.hidden = true
        button.setAttribute('aria-expanded', false)
    }
}

function open(controlId) {
    const { container, button, animationFrame } = readMoreInstances[controlId]

    if (animationFrame) {
        cancelAnimationFrame(animationFrame)
    }

    container.hidden = false
    container.style.height = Math.ceil(container.scrollHeight) + 'px'
    container.dataset.active = true
    button.setAttribute('aria-expanded', 'true')
    readMoreInstances[controlId].isOpen = true
}

function close(controlId) {
    const { container, animationFrame } = readMoreInstances[controlId]

    if (animationFrame) {
        cancelAnimationFrame(animationFrame)
    }

    container.style.height = Math.ceil(container.scrollHeight) + 'px'

    readMoreInstances[controlId].animationFrame = requestAnimationFrame(() => {
        container.removeAttribute('data-active')
        container.style.height = 0
        readMoreInstances[controlId].animationFrame = null
    })

    readMoreInstances[controlId].isOpen = false
}
